import React, { useState } from 'react';

// High-level audit trail of one customer (server: customer_events), newest
// first. Shown at the bottom of the customer details.

const CATEGORY = {
  created:                   'Created',
  details_updated:           'Details updated',
  pip_check:                 'PIP check',
  status_changed:            'Status',
  reopened:                  'Re-opened',
  committee_decision:        'Committee',
  risk_assessed:             'Risk rating',
  edd_required:              'EDD',
  screened:                  'Screening',
  screening_hit_reviewed:    'Screening review',
  document_uploaded:         'Document',
  document_new_version:      'Document',
  document_verified:         'Document',
  document_deleted:          'Document',
  document_metadata_updated: 'Document',
  hrc_requested:             'High-Risk Committee',
  hrc_decided:               'High-Risk Committee',
  hrc_withdrawn:             'High-Risk Committee',
  case_opened:               'Case',
  case_closed:               'Case',
  case_reopened:             'Case',
  cdd_review_completed:      'CDD review'
};

const formatWhen = (ts) => {
  const d = new Date(ts);
  if (isNaN(d.getTime())) return '—';
  const p = (n) => String(n).padStart(2, '0');
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}, ${p(d.getHours())}:${p(d.getMinutes())}`;
};

function CustomerAuditTrail({ events }) {
  const [filter, setFilter] = useState('all');
  const list = Array.isArray(events) ? events : [];
  const categories = [...new Set(list.map((e) => CATEGORY[e.event_type] || e.event_type))];
  const shown = filter === 'all' ? list : list.filter((e) => (CATEGORY[e.event_type] || e.event_type) === filter);

  return (
    <section className="form-section" style={{ marginTop: '1rem' }}>
      <header className="form-section__head" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>
        <h4 className="form-section__title" style={{ flex: 1 }}>Audit trail ({list.length})</h4>
        {categories.length > 1 && (
          <select value={filter} onChange={(e) => setFilter(e.target.value)} style={{ maxWidth: '220px' }}>
            <option value="all">All activity</option>
            {categories.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        )}
      </header>

      {shown.length === 0 ? (
        <p style={{ fontSize: '0.85rem', color: 'var(--text-secondary,#607d8b)' }}>No activity recorded yet.</p>
      ) : (
        <div className="table-container" style={{ maxHeight: '360px', overflowY: 'auto' }}>
          <table className="pips-table">
            <thead>
              <tr>
                <th style={{ whiteSpace: 'nowrap' }}>When</th>
                <th>What</th>
                <th>Details</th>
                <th>By</th>
              </tr>
            </thead>
            <tbody>
              {shown.map((e) => (
                <tr key={e.id}>
                  <td style={{ whiteSpace: 'nowrap' }}>{formatWhen(e.created_at)}</td>
                  <td style={{ whiteSpace: 'nowrap' }}>
                    <span className="un-meta__pill">{CATEGORY[e.event_type] || e.event_type}</span>
                  </td>
                  <td>{e.summary}</td>
                  <td>{e.actor_name || e.actor_email || 'System'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}

export default CustomerAuditTrail;
